module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kMdqa"))).then(() => parcelRequire('1iHdE'));